import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineRounded";
import { Button, Stack } from "@mui/material";

interface Props {
  selectedIds: string[];
  deleteTemplates: (ids: string[]) => void;
}

export default function OrganizationTemplateGridCustomHeader({ selectedIds, deleteTemplates }: Props) {
  return (
    <Stack direction="row" sx={{ gap: 1 }}>
      <Button
        variant="text"
        color="error"
        startIcon={<DeleteOutlineIcon color="error" />}
        onClick={() => deleteTemplates(selectedIds)}
      >
        Delete
      </Button>
    </Stack>
  );
}
